import styled from 'styled-components';
import { colors } from '~/styles';

const ListViewActionsLoading = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  background-color: ${colors.primary50};
  border-color: ${colors.primary50};
  margin-top: -1px;
  margin-bottom: -1px;
  margin-right: -1px;
  position: relative;

  &:hover {
    cursor: default;
  }

  &::after {
    position: absolute;
    left: calc(50% - (1em / 2));
    top: calc(50% - (1em / 2));
    animation: spinAround 0.5s infinite linear;
    border: 2px solid #dbdbdb;
    border-radius: 290486px;
    border-right-color: transparent;
    border-top-color: transparent;
    content: '';
    display: block;
    height: 1em;
    width: 1em;
  }
`;

export default ListViewActionsLoading;
